export default [
  // 重定向
  {
    path: "/",
    redirect: "/home",
  },
  {
    name: "home",
    path: "/home",
    component: () => import("@/views/Home"),
    meta: {
      title: '首页',
      show_header: true,
      show_footer: true,
    },
  },
  {
    name: "product",
    path: "/product",
    component: () => import("@/views/Product"),
    meta: {
      title: '技术产品',
      show_header: true,
      show_footer: true,
    },
  },
  {
    name: "certificate",
    path: "/certificate",
    component: () => import("@/views/Certificate"),
    meta: {
      title: '专利证书',
      show_header: true,
      show_footer: true,
    },
  },
  {
    name: "project",
    path: "/project",
    component: () => import("@/views/Project"),
    meta: {
      title: '工程业绩',
      show_header: true,
      show_footer: true,
    },
  },
  {
    name: "about",
    path: "/about",
    component: () => import("@/views/About"),
    meta: {
      title: '关于我们',
      show_header: true,
      show_footer: true,
    },
  },
  {
    name: "news",
    path: "/news",
    component: () => import("@/views/News"),
    meta: {
      title: '新闻资讯',
      show_header: true,
      show_footer: true,
    },
  },
  {
    name: "article",
    path: "/article/:id",
    component: () => import("@/views/Article"),
    meta: {
      title: '新闻资讯',
      show_header: true,
      show_footer: true,
    },
  },
  {
    name: "console-ban",
    path: "/console-ban",
    component: () => import("@/components/ConsoleBan"),
    meta: {
      title: 'console-ban',
    },
  },
  {
    name: "test",
    path: "/test",
    component: () => import("@/views/Test"),
    meta: {
      title: '代码测试',
    },
  },
];
